import type { PainLogConfig } from "@/lib/schema";
import type { WidgetSettingsEditorProps } from "@/widgets/types";

type Props = WidgetSettingsEditorProps<PainLogConfig>;

export function SettingsEditor({
  config,
  onChange,
  errors = {},
  scoringField,
}: Props) {
  const fieldError = (key: string) =>
    errors[key] ? (
      <p className="field-error" data-testid={`widget-error-${key}`}>
        {errors[key]}
      </p>
    ) : null;

  return (
    <div
      className="widget-settings"
      data-testid={`widget-settings-${config.id}`}
    >
      <div className="setting-row">
        <label className="setting-label" htmlFor={`label-${config.id}`}>
          Tittel
        </label>
        <div className="setting-control">
          <input
            id={`label-${config.id}`}
            className="input"
            type="text"
            value={config.label}
            onChange={(e) => onChange({ label: e.target.value })}
            data-testid="widget-label-input"
          />
          {fieldError("label")}
        </div>
      </div>

      <div className="setting-row">
        <label className="setting-label" htmlFor={`points-${config.id}`}>
          Poeng
          <small>
            For hver dag smertenivået er satt. Symptomer og notat er frivillige.
          </small>
        </label>
        <div className="setting-control">
          <div className="num-input">
            <input
              id={`points-${config.id}`}
              type="number"
              min={0.25}
              step={0.25}
              value={Number.isFinite(config.points) ? config.points : ""}
              onChange={(e) =>
                onChange({
                  points:
                    e.target.value === "" ? Number.NaN : Number(e.target.value),
                })
              }
              data-testid="widget-points-input"
            />
            <span className="unit">p</span>
          </div>
          {fieldError("points")}
        </div>
      </div>

      {scoringField}
    </div>
  );
}
